import comp from "./UnitSelectionPage";
export default comp;
